import { NavItem } from '../full/vertical/sidebar/nav-item/nav-item';

// ============================================================================
//  Menús del rol Doctor — 4 variantes según el contexto de consulta activo
//  (patientId / internalConsultationId en localStorage). Fuente única para
//  ambos layouts (antes duplicado entre horizontal y vertical).
// ============================================================================

const pacientesBase: NavItem[] = [
  {
    displayName: 'Pacientes en hospital',
    iconName: 'heart-rate-monitor',
    route: 'consulta/pacientes-en-hospital',
  },
  {
    displayName: 'Pacientes en consultorio',
    iconName: 'stethoscope',
    route: 'consulta/pacientes-en-consultorio',
  },
  {
    displayName: 'Pacientes en atención interna',
    iconName: 'emergency-bed',
    route: 'consulta/pacientes-en-atencion-interna',
  },
];

const misPacientes: NavItem = {
  displayName: 'Mis pacientes',
  iconName: 'users',
  route: 'consulta/lista-de-pacientes',
};

const consultaExternaActual = (label: string): NavItem => ({
  displayName: label,
  iconName: 'clipboard-heart',
  route: 'consulta/consulta-actual',
});

const consultaInternaActual: NavItem = {
  displayName: 'Consulta interna actual',
  iconName: 'clipboard-heart',
  route: 'consulta/consulta-atencion-interna',
};

// Con consulta externa activa (patientId, sin internalConsultationId)
export const navItemsDoctorConsultory: NavItem[] = [
  { navCap: 'Consulta' },
  ...pacientesBase,
  consultaExternaActual('Consulta actual'),
  misPacientes,
];

// Alias usado por el layout horizontal (mismo menú)
export const navItemsConsultory = navItemsDoctorConsultory;

// Sin consulta activa
export const navItemsDoctorConsultoryWithOutCurrentConsulting: NavItem[] = [
  { navCap: 'Consulta' },
  ...pacientesBase,
  misPacientes,
];

// Con consulta externa E interna activas
export const navItemsConsultoryWithExternalAndInternal: NavItem[] = [
  { navCap: 'Consulta' },
  ...pacientesBase,
  consultaExternaActual('Consulta externa actual'),
  consultaInternaActual,
  misPacientes,
];

// Solo consulta interna activa
export const navItemsConsultoryWithInternalWithOutExternal: NavItem[] = [
  { navCap: 'Consulta' },
  ...pacientesBase,
  consultaInternaActual,
  misPacientes,
];
